import { Component, OnInit } from "@angular/core";
import { ProfileService } from "../services/profile.service";
import { ProfileInterface } from "../profile-interface";
import { Profile } from "../profile";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { COUNTRIES } from "../countries";
import { UserService } from "../services/user.service";
import { LoaderService } from "../services/loader.service";
import { FeedbackService } from "../services/feedback.service";
import { LogService } from "../services/log.service";
@Component({
  selector: "app-my-profile",
  templateUrl: "./my-profile.component.html",
  styleUrls: ["./my-profile.component.css"]
})
export class MyProfileComponent implements OnInit {
  public studentDetails: any = [];
  selectedFile: File = null;
  public genders = [{ value: "Male" }, { value: "Female" }];
  public maritals = [{ value: "Single" }, { value: "Married" }];
  public countries = COUNTRIES;
  public country;
  public states;
  public disp;
  public pForm: FormGroup;
  public firstname: string;
  public lastName: string;
  public middleName: string;
  public dateOfBirth: string;
  public phone1: string;
  public phone2: string;
  public nationality: string;
  public state_of_origin: string;
  public gender: string;
  public maritalStatus: string;
  public address: string;
  public k_name: string;
  public k_phone: string;
  public email: string;
  public k_email: string;
  public studentId: string;
  public disableSelect: boolean;
  public response: string = "";
  public respDisp: string = "";
  public lastname;
  public first_name;
  public student_id;
  public dept;
  public programme;
  public level;
  public semester;
  public myForm: FormGroup;
  public saveProfile = false;
  public isFullyLoaded;
  public isFullyLoaded2;
  public studentPassport;
  public passport;
  public image;
  public _gender;
  constructor(
    private _profileService: ProfileService,
    private _http: HttpClient,
    private fb: FormBuilder,
    private _userService: UserService,
    private _loaderService: LoaderService,
    private _feedbackService: FeedbackService,
    public log: LogService
  ) { }

  ngOnInit() {
    this._loaderService.emitChange(true);
    this.log
      .addLog({
        action: "Access",
        component: "My Profile",
        details: `Fetched Profile`,
      })
      .subscribe((data) => { });
    this.myForm = this.fb.group({
      firstName: ["", [Validators.required, Validators.maxLength(30)]],
      lastName: ["", [Validators.required, Validators.maxLength(30)]],
      email: ["", [Validators.required, Validators.maxLength(60), Validators.email]],
      middleName: ["", [Validators.maxLength(30)]],
      dateOfBirth: ["", [Validators.required, Validators.maxLength(10)]],
      nationality: [""],
      stateOfOrigin: [""],
      gender: ["", [Validators.required]],
      address: ["", Validators.maxLength(200)],
      maritalStatus: [""],
      phone1: ["", [Validators.required, Validators.maxLength(14)]],
      phone2: ["", [Validators.maxLength(14)]],
      k_phone: ["", [Validators.maxLength(14)]],
      k_name: ["", Validators.maxLength(50)],
      k_email: ["", [Validators.maxLength(60), Validators.email]]
    });
    this.myForm.disable();
    this._userService.getUserData().subscribe(data => {


      this.myForm.controls["lastName"].setValue(data.lastname);
      this.myForm.controls["firstName"].setValue(data.firstname);
      this.myForm.controls["dateOfBirth"].setValue(data.date_of_birth);
      this.myForm.controls["email"].setValue(data.email);
      this.myForm.controls["middleName"].setValue(data.middlename);
      this.myForm.controls["nationality"].setValue(data.nationality);
      this.myForm.controls["stateOfOrigin"].setValue(data.state_of_origin);
      this.myForm.controls["gender"].setValue(data.gender);
      this.myForm.controls["address"].setValue(data.address);
      this.myForm.controls["phone1"].setValue(data.phone_1);
      this.myForm.controls["phone2"].setValue(data.phone_2);
      this.myForm.controls["k_phone"].setValue(data.rphone1_1);
      this.myForm.controls["k_name"].setValue(data.rfullname_1);
      this.myForm.controls["k_email"].setValue(data.remail_1);
      this.myForm.controls["maritalStatus"].setValue(data.marital_status);
      this.studentPassport = data.passport;
      this.image = "" + data.passport;
      console.log(data.passport, 'datattta');
      //student state of origin
      let selectedCountry = data.nationality;
      for (let x = 0; x < this.countries.length; x++) {
        if (this.countries[x].country == selectedCountry) {
          this.country = this.countries[x];
          this.disp = this.country.states;
          break;
        }
      }
      this._loaderService.emitChange(false);
      this._gender = data.gender;
    });
  }

  displayStates(event) {
    let selectedCountry = event.value;
    let y;
    for (let x = 0; x < this.countries.length; x++) {
      if (this.countries[x].country == selectedCountry) {
        this.country = this.countries[x];
        this.disp = this.country.states;
        break;
      }
    }
  }
  displayPassport(files: File[], form) {
    if (files.length > 0) {
      this.selectedFile = files[0];
      // console.log(this.selectedFile);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.image = event.target.result;
        this.myForm.value.passport = this.image;
        //console.log(event.target.result);
      };

      reader.readAsDataURL(this.selectedFile);
      this.passport = this.selectedFile.name;
      //console.log(event);
    }
    this.updateProfile(form);
  }

  editProfile() {
    this.myForm.enable();
    this.saveProfile = true;
  }
  updateProfile(user) {
    this.myForm.markAllAsTouched();
    if (this.myForm.invalid) return;

    this._loaderService.emitChange(true);
    let fd;
    if (this.selectedFile == null) {
      fd = user; //update without passport if passport was not changed
      //console.log(fd);
    } else {
      //update all including passport if passport was changed
      fd = new FormData();
      fd.append("textData", JSON.stringify(user));
      fd.append("with_passport", true);
      fd.append("passport", this.selectedFile, this.selectedFile.name);

    }
    // let modDate = fd.dateOfBirth.split('-');
    // fd.dateOfBirth = modDate[0] + "-" + modDate[1] + "-" + modDate[2];
    // console.log(fd.dateOfBirth);


    this._userService.updateDetails(fd).subscribe(data => {
      if (data.success) {
        this._feedbackService.emitChange("Profile updated successfully", "primary-color");
        this._userService.emitChange(true);
        this.log
          .addLog({
            action: "Edit",
            component: "My Profile",
            details: `Edited Profile`,
          })
          .subscribe((data) => { });
      } else {
        this._feedbackService.emitChange("Failed! " + data.message, "failed-color");
      } ``
      this._loaderService.emitChange(false);
    });
    this.myForm.disable();
    this.saveProfile = false;
  }
}
